/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-08 00:00:00
 *
 *******************************************************/
// import _ from 'lodash';

import React, { Component } from 'react';
import { Modal, Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { TEMPLATE_FEATURE } from 'src/constants/shopify-integration';
import { getThemeReviewUrl, getFullAppUrlThemeEditor } from 'src/helpers';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class WidgetAlreadyAddedModal extends Component<ComposedProps, State> {
  navigateToThemeEditor = () => {
    const { feature } = this.props;
    const previewUrl = getFullAppUrlThemeEditor(this.props.selectedThemeId);
    const previewPath = {
      [TEMPLATE_FEATURE.COLLECTION]: '/collections/frontpage',
      [TEMPLATE_FEATURE.SEARCH]: '/search'
    };
    window.open(`${previewUrl}?previewPath=${previewPath[feature]}`, '_blank');
  };

  navigateToPreview = () => {
    const { selectedThemeId } = this.props;
    const previewUrl = getThemeReviewUrl(selectedThemeId);
    window.open(previewUrl, '_blank');
  };

  render() {
    const { i18n, open, onClose, feature, isOS20 } = this.props;

    const description = {
      [TEMPLATE_FEATURE.COLLECTION]: i18n.translate(
        'AdminHTML.ShopifyIntegration.WidgetAlreadyAddedModal.description_collection'
      ),
      [TEMPLATE_FEATURE.SEARCH]: i18n.translate(
        'AdminHTML.ShopifyIntegration.WidgetAlreadyAddedModal.description_search'
      )
    };
    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          title={i18n.translate('AdminHTML.ShopifyIntegration.WidgetAlreadyAddedModal.title')}
          primaryAction={[
            {
              content: isOS20
                ? i18n.translate('AdminHTML.ShopifyIntegration.Actions.gotoThemeEditor')
                : i18n.translate('AdminHTML.ShopifyIntegration.Actions.preview'),
              onAction: isOS20 ? this.navigateToThemeEditor : this.navigateToPreview
            }
          ]}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.close'),
              onAction: onClose
            }
          ]}>
          {/* Content */}
          <div className="warning-add-widget-live-modal">
            <Card>
              <Card.Section>
                <div className="content">
                  <p>{description[feature]}</p>
                </div>
              </Card.Section>
            </Card>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withI18n()(WidgetAlreadyAddedModal);
